import { Card, CardProps } from "@mantine/core";
import { useComputedColorScheme } from "@mantine/core";
import React from "react";

interface AppCardProps extends Omit<CardProps, "children"> {
  children: React.ReactNode;
  className?: string;
}

export default function AppCard({
  children,
  className,
  ...props
}: AppCardProps) {
  const colorScheme = useComputedColorScheme();

  return (
    <Card
      shadow="sm"
      radius="md"
      className={`card-base ${className || ""}`}
      {...props}
    >
      {children}
    </Card>
  );
}
